module.exports = __webpack_public_path__ + "media/src/images/kyozai-fde785edaf2a54828f6b92576e4dd654.png";